<div class="wrapper has-padding inline">
    <div [innerHTML]="language"></div>
</div>
